var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-3"},[_vm._v(" Sign up for "+_vm._s(_vm.typeTextual)+" analytical roundups of cyber threat developments. This will be sent at the end of each "+_vm._s(_vm.typeSingular)+". ")])}
var staticRenderFns = []

export { render, staticRenderFns }